import { c as _c } from "react/compiler-runtime";
import type { ComparisonTableColumn, ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { theme } from '@cc-shopping/ui/theme';
import { useMediaQuery } from '@mui/material';
import { createContext, useContext } from 'react';
export const MAXIMUM_COLUMNS_MOBILE = 2;
export const MAXIMUM_COLUMNS_DESKTOP = 3;
type ComparisonTableContextValue = {
  columns: ComparisonTableColumn[];
  driversIds: string[];
  numberOfColumns: number;
};
const ComparisonTableContext = createContext<ComparisonTableContextValue>({
  columns: [],
  driversIds: [],
  numberOfColumns: 0
});
type ComparisonTableContextProviderProps = {
  comparisonTable: ReviewCreditCardsPage['comparisonTable'];
  children: React.JSX.Element | ((args: ComparisonTableContextValue) => React.JSX.Element);
  pagePosition?: number;
};
export default function ComparisonTableContextProvider(t0) {
  const $ = _c(9);
  const {
    comparisonTable,
    children,
    pagePosition
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = theme.breakpoints.down("md");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const isMobile = useMediaQuery(t1);
  const columns = comparisonTable?.columns;
  if (!columns || columns.length < 2) {
    return null;
  }
  let t2;
  let t3;
  if ($[1] !== children || $[2] !== columns || $[3] !== isMobile || $[4] !== pagePosition) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let actualColumns = columns;
      if (isMobile) {
        actualColumns = columns.slice(0, MAXIMUM_COLUMNS_MOBILE);
      } else {
        if (columns.length > MAXIMUM_COLUMNS_DESKTOP) {
          actualColumns = columns.slice(0, MAXIMUM_COLUMNS_DESKTOP);
        }
      }
      const numberOfColumns = actualColumns.length;
      if (pagePosition !== undefined) {
        let t4;
        if ($[7] !== pagePosition) {
          t4 = column => ({
            ...column,
            marketplaceEntity: {
              ...column.marketplaceEntity,
              analytics: {
                ...column.marketplaceEntity.analytics,
                sectionPosition: pagePosition
              }
            }
          });
          $[7] = pagePosition;
          $[8] = t4;
        } else {
          t4 = $[8];
        }
        actualColumns = actualColumns.map(t4);
      }
      const firstColumn = actualColumns[0];
      const driversIds = firstColumn.drivers?.map(_temp);
      if (!driversIds || driversIds.length === 0) {
        t3 = null;
        break bb0;
      }
      const context = {
        columns: actualColumns,
        driversIds,
        numberOfColumns
      };
      t2 = <ComparisonTableContext.Provider value={context}>{typeof children === "function" ? children(context) : children}</ComparisonTableContext.Provider>;
    }
    $[1] = children;
    $[2] = columns;
    $[3] = isMobile;
    $[4] = pagePosition;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  return t2;
}
function _temp(driver) {
  return driver.id;
}
export const useComparisonTableContext = () => {
  const comparisonTableContext = useContext(ComparisonTableContext);
  return comparisonTableContext;
};